import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
    selector: 'pg-layout-user-portal',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './layout-user-portal.component.html',
    styleUrls: ['layout-user-portal.component.scss'],
})
export class LayoutUserPortalComponent implements OnInit {
    constructor() {}
    ngOnInit() {}
}
